import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getKategoriRpl = 'sertifikasi-rpl/kategori-sertifikasi-rpl';
const getSertifikasiRpl = 'sertifikasi-rpl/kategori-rpl/';
const getDataPeserta = 'data-peserta/data-peserta-sertifikasi-rpl';

const detailDataPeserta = 'jadwal-test-center/dokumen-pendukung-peserta-rpl';
const ProsesAdministrasiUrl = 'data-peserta/sertifikasi-peserta-rpl/proses-administrasi/';

const getMataUjiPesertaSertifikasi = 'data-peserta/data-peserta-sertifikasi-rpl/mata-uji-peserta';

class DataPesertaRplService {
    getDataPeserta(currentPage, pageSize, filter, id_sertifikasi, status_pembayaran) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            filter: filter,
            id_sertifikasi: id_sertifikasi,
            status_pembayaran : status_pembayaran 
        }
        return axios.get(
            API_URL + getDataPeserta,
            {
                headers: authHeader(),
                params: data
            });
    }

    getMataUjiPesertaSertifikasi(currentPage, pageSize, filter, idSertifikasiPeserta) {
        var data = {
            pageNo: currentPage,
            pageSize: pageSize,
            filter: filter,
            idSertifikasiPeserta: idSertifikasiPeserta
        }
        return axios.get(
            API_URL + getMataUjiPesertaSertifikasi,
            {
                headers: authHeader(),
                params: data
            });
    }

    getKategoriRpl() {
        return axios.get(
            API_URL + getKategoriRpl,
            {
                headers: authHeader()
            }
        );

    }

    getSertifikasiRpl(idKategoriSertifikasiRpl) {
        return axios.get(
            API_URL + getSertifikasiRpl + idKategoriSertifikasiRpl,
            {
                headers: authHeader()
            }
        );

    }

    detailDataPeserta(idSertifikasiRplPeserta) {
        var data = {
            idSertifikasiRplPeserta: idSertifikasiRplPeserta
        }
        return axios
            .get(
                API_URL + detailDataPeserta,
                {
                    headers: authHeader(),
                    params: data
                }
            );
    }

    putSendProsesAdministrasiRpl(formProsesAdministrasi) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + ProsesAdministrasiUrl + formProsesAdministrasi.id_sertifikasi_rpl_peserta,
                formProsesAdministrasi,
                { headers: { 'Content-Type': 'application/json', 'Authorization': tokenHeader() } }
            );
    }

}

export default new DataPesertaRplService();